// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__3c4UH","container":"Modal_container__gi8Oo","content":"Modal_content__1QhBp"};